import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, MapPin, Phone, Mail } from 'lucide-react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-blue-50 to-white py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-semibold mb-8">
          <ArrowLeft className="w-5 h-5" />
          Back to Home
        </Link>
        
        <div className="bg-white rounded-2xl shadow-xl p-8 border-4 border-blue-600">
          <h1 className="text-4xl font-black text-gray-900 mb-6 text-center">Contact Us</h1>
          <p className="text-lg text-gray-600 mb-8 text-center">
            Get in touch with the FltrLnk team. We're here to help!
          </p>
          
          <div className="space-y-8">
            {/* Address */}
            <div className="flex items-start gap-4 p-6 bg-blue-50 rounded-xl border-2 border-blue-200 hover:border-blue-400 transition-colors">
              <div className="bg-blue-600 p-3 rounded-full">
                <MapPin className="w-6 h-6 text-white" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-900 mb-2">Our Address</h2>
                <p className="text-gray-700 text-lg leading-relaxed">
                  5955 Alpha Rd Ste 102 #5200<br />
                  Dallas, TX 75240
                </p>
              </div>
            </div>

            {/* Phone */}
            <div className="flex items-start gap-4 p-6 bg-green-50 rounded-xl border-2 border-green-200 hover:border-green-400 transition-colors">
              <div className="bg-green-600 p-3 rounded-full">
                <Phone className="w-6 h-6 text-white" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-900 mb-2">Phone Number</h2>
                <a href="tel:469-807-7570" className="text-green-600 text-lg font-semibold hover:text-green-700 hover:underline">
                  469-807-7570
                </a>
              </div>
            </div>

            {/* Email */}
            <div className="flex items-start gap-4 p-6 bg-purple-50 rounded-xl border-2 border-purple-200 hover:border-purple-400 transition-colors">
              <div className="bg-purple-600 p-3 rounded-full">
                <Mail className="w-6 h-6 text-white" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-900 mb-2">Email</h2>
                <a href="mailto:support@fltrlnk.com" className="text-purple-600 text-lg font-semibold hover:text-purple-700 hover:underline">
                  support@fltrlnk.com
                </a>
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-8 p-6 bg-gradient-to-r from-red-50 via-white to-blue-50 rounded-xl border-2 border-gray-200">
            <h3 className="text-xl font-bold text-gray-900 mb-3">Business Hours</h3>
            <p className="text-gray-700">
              <strong>Monday - Friday:</strong> 9:00 AM - 6:00 PM CST<br />
              <strong>Saturday - Sunday:</strong> Closed
            </p>
          </div>

          {/* Support Note */}
          <div className="mt-8 text-center p-6 bg-blue-600 text-white rounded-xl">
            <h3 className="text-2xl font-bold mb-2">Need Support?</h3>
            <p className="text-lg">
              For technical support or account issues, email us at{' '}
              <a href="mailto:support@fltrlnk.com" className="underline font-bold hover:text-yellow-300">
                support@fltrlnk.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
